export default __webpack_public_path__ + "static/bg9-cf9a123e2a3d371d53da8b7fdb2f5b49.jpg";